import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import { browserHistory } from 'react-router'
import classnames from 'classnames'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

import { clearNotifications } from '_modules/notification/actions'
import { getTasks } from '_modules/log/actions'
import { updateTaskStatus, startTask } from '_modules/current-task/actions'
import { decrementCounter, startTimer } from '_modules/counter/actions'
import { sortOccurenceByStartedAt } from '_utils/sort'
import { getCounterValue, getMindfulBreakDuration } from '_utils/counter'
import Icon from '_components/icon'
import { iconForTaskStatus } from '_utils/icon'
import { USER_STATUS_TYPES } from '_utils/userStatusType'
import Socket from '_utils/socket'

import styles from './styles.css'

momentDurationFormatSetup(moment)

const mapStateToProps = ({ user, log, counter, mindfulBreaks, settings }) => ({
  user,
  logs: log,
  counter,
  mindfulBreaks,
  settings,
})

const mapDispatchToProps = {
  getTasks,
  decrementCounter,
  updateTaskStatus,
  startTimer,
  startTask,
  clearNotifications,
}

class LogDetails extends PureComponent {
  static propTypes = {
    user: ImmutableProptypes.map,
    logs: ImmutableProptypes.map,
    counter: ImmutableProptypes.map,
    mindfulBreaks: ImmutableProptypes.map,
    settings: ImmutableProptypes.map,
    getTasks: PropTypes.func.isRequired,
    decrementCounter: PropTypes.func.isRequired,
    updateTaskStatus: PropTypes.func.isRequired,
    startTimer: PropTypes.func.isRequired,
    startTask: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    clearNotifications: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
    logs: new Map(),
    counter: new Map(),
    mindfulBreaks: new Map(),
    settings: new Map(),
    currentTask: new Map(),
  }

  state = {
    log: new Map(),
  }

  componentWillMount() {
    const { id, logs } = this.props
    if (logs.get(id)) {
      const selectedLog = logs.get(id)
      const sameTaskLogs = logs.filter(log => log.get('name') === selectedLog.get('name'))
      const taskAggregOcc = sameTaskLogs.reduce((aggTask, item) => {
        if (item.get('_id') === aggTask.get('_id')) {
          return aggTask
        }

        const currentOcc = aggTask.get('occurences')
        const newOcc = currentOcc.concat(item.get('occurences'))
        return aggTask.set('occurences', newOcc)
      }, selectedLog)
      this.setState({
        log: taskAggregOcc,
      })
    }
  }

  componentDidMount() {
    this.props.getTasks()
    // this.props.getTask(this.props.id)
  }

  componentWillReceiveProps(nextProps) {
    const { id, logs } = nextProps
    if (logs.get(id)) {
      const selectedLog = logs.get(id)
      const sameTaskLogs = logs.filter(log => log.get('name') === selectedLog.get('name'))
      const taskAggregOcc = sameTaskLogs.reduce((aggTask, item) => {
        if (item.get('_id') === aggTask.get('_id')) {
          return aggTask
        }

        const currentOcc = aggTask.get('occurences')
        const newOcc = currentOcc.concat(item.get('occurences'))
        return aggTask.set('occurences', newOcc)
      }, selectedLog)
      this.setState({
        log: taskAggregOcc,
      })
    }
  }

  onPlayClick = event => {
    event.stopPropagation()
    const { counter, logs, id, mindfulBreaks, settings } = this.props

    if (counter.get('intervalId') !== null) {
      return
    }

    const task = logs.get(id)
    const name = task.get('name')

    if (task.getIn(['occurences', -1, 'status']) !== 2) {
      this.props.updateTaskStatus(id)
    }

    const flexibleTime = settings.get('flexibleTime')

    browserHistory.push({
      pathname: '/',
      state: {
        name,
        action: 'start',
        logEntry: id,
        flexibleTime,
        type: 1,
      },
    })
  }

  onBackClick = () => {
    // browserHistory.push('/log')
    browserHistory.goBack()
  }

  getTimeSpent = occurrences => {
    const result = occurrences.reduce((res, occ) => {
      const diff = occ.endedAt
        ? moment(occ.endedAt, 'YYYY-MM-DDTHH:mm:ss.SSSZ').diff(
            moment(occ.startedAt, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
          )
        : 0
      return res + diff
    }, 0)
    return Math.round(result / 60000)
  }

  getPlusTime = occurrences => {
    const result = occurrences.reduce((res, occ) => {
      const diff = occ.endedAt
        ? moment(occ.settledAt, 'YYYY-MM-DDTHH:mm:ss.SSSZ').diff(
            moment(occ.endedAt, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
          )
        : 0

      if (diff < 0) return res
      return res + diff
    }, 0)
    return Math.round(result / 60000)
  }

  groupOccurenceByDate = occurences =>
    occurences.reduce((groups, item) => {
      const day = moment(item.startedAt).format('YYYY-MM-DD')
      if (groups[day]) {
        const dayArray = groups[day]
        dayArray.push(item)
        return { ...groups, [day]: dayArray }
      }
      return { ...groups, [day]: [item] }
    }, {})

  timer = () => {
    this.props.decrementCounter()
  }

  renderOccurence = occurence => {
    const iconName = iconForTaskStatus(occurence.status)

    return (
      <li key={occurence._id} className={classnames(styles['Grid-cell'], styles.occurence)}>
        <div className={classnames(styles.Grid, styles['Grid--alignCenter'])}>
          <div className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.status)}>
            <Icon type={iconName} isButton={false} />
          </div>
          <div className={classnames(styles['Grid-cell'], styles['u-sizeFill'])}>
            {moment(occurence.startedAt).format('hh:mm A')} -{' '}
            {occurence.endedAt ? moment(occurence.endedAt).format('hh:mm A') : 'Now'}
          </div>
        </div>
      </li>
    )
  }

  renderOccurenceGroup = (groups, date, focusTime, plusTime) => {
    let timeSpentText = `${focusTime} min`
    if (plusTime) timeSpentText += ` (+${plusTime} min)`

    return (
      <li
        className={classnames(styles.Grid, styles['Grid--alignCenter'], styles['task-detail'])}
        key={date}
      >
        <div className={classnames(styles['Grid-cell'])}>
          <div className={classnames(styles.Grid, styles['Grid--alignMiddle'])}>
            <div className={classnames(styles['Grid-cell'], styles['u-sizeFill'], styles.date)}>
              {date}
            </div>
            <div
              className={classnames(styles['Grid-cell'], styles['u-sizeFill'], styles.timeSpent)}
            >
              <p>{timeSpentText}</p>
            </div>
          </div>
        </div>
        <ul className={classnames(styles['Grid-cell'])}>
          {groups.map(occurence => this.renderOccurence(occurence))}
        </ul>
      </li>
    )
  }

  render() {
    const { log } = this.state
    const task = log.toJS()
    const playButtonDisabled = this.props.counter.get('status') === 'in progress'
    const groupedOccurences = this.groupOccurenceByDate(
      (task.occurences || []).sort(sortOccurenceByStartedAt)
    )

    return (
      <div className={classnames(styles.Grid, styles['Grid--alignCenter'], styles.main)}>
        <div className={classnames(styles['Grid-cell'], styles['details-container'])}>
          <div
            className={classnames(
              styles.Grid,
              styles['Grid--alignMiddle'],
              styles['Grid--alignCenter'],
              styles.taskName
            )}
          >
            <p className={classnames(styles['Grid-cell'], styles['u-sizeFill'], styles.name)}>
              {task.name}
            </p>
          </div>
          {Object.keys(groupedOccurences).length !== 0 && (
            <div>
              <ul className={classnames(styles['Grid-cell'])}>
                {Object.keys(groupedOccurences).map(date =>
                  this.renderOccurenceGroup(
                    groupedOccurences[date],
                    moment(date).calendar(null, {
                      sameDay: '[Today]',
                      nextDay: '[Tomorrow]',
                      nextWeek: 'MMM Do',
                      lastDay: '[Yesterday]',
                      lastWeek: 'MMM Do',
                      sameElse: 'MMM Do',
                    }),
                    this.getTimeSpent(groupedOccurences[date]),
                    this.getPlusTime(groupedOccurences[date])
                  )
                )}
              </ul>
            </div>
          )}
          <div style={{ marginTop: 40 }}>
            <Icon type="start" isButton disabled={playButtonDisabled} onClick={this.onPlayClick} />
          </div>
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-sizeFit'])}>
          <button className={classnames(styles['back-button'])} onClick={this.onBackClick}>
            Back
          </button>
        </div>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogDetails)



// WEBPACK FOOTER //
// ./src/views/log/details/index.js